module.exports = "<svg viewBox=\"0 0 21 12\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.4 12H3.103a1.2 1.2 0 110-2.4H6.89a1.2 1.2 0 100-2.4H1.2a1.2 1.2 0 110-2.4h4.738a1.2 1.2 0 100-2.4H4.53a1.2 1.2 0 110-2.4h9.87a6 6 0 110 12zm0-1.2a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6zm.658-4.997l1.328 1.341c.23.232.23.605 0 .837a.583.583 0 01-.824.005l-.005-.005-1.41-1.425a1.2 1.2 0 01-.347-.844V3.586a.586.586 0 111.172 0v2.006a.3.3 0 00.086.21z\" fill=\"#68a51c\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/brands/asda-brand-express-small.svg
// module id = 642
// module chunks = 0